import { useQuery } from '@tanstack/react-query';

export interface City {
  ib: number; // ibge code
  n: string; // name
  la: number; // latitude
  lo: number; // longitude
  uf: number; // state code
}

const fetchCities = async (): Promise<City[]> => {
  const response = await fetch('/data/municipios.json');
  if (!response.ok) {
    throw new Error('Erro ao carregar os municípios');
  }
  return response.json();
};

export function useCities(stateCode?: number) {
  const {
    data: allCities,
    isLoading,
    isFetching,
    isRefetching,
  } = useQuery({
    queryKey: ['cities'],
    queryFn: fetchCities,
    staleTime: 1000 * 60 * 60 * 24 * 30, // Cache de 30 dias
  });

  const filteredCities = allCities
    ?.filter((city) => (stateCode ? city.uf === stateCode : true))
    .sort((a, b) => a.n.localeCompare(b.n));

  return {
    cityData: filteredCities || [],
    isLoading: isLoading || isFetching || isRefetching,
  };
}
